export function distributeTrophies(leaderboard) {
  const competitors = leaderboard.length;

  if (competitors <= 50) return trophiesDistribution(leaderboard, 1, 2, 5, 10);
  else if (competitors <= 100) return trophiesDistribution(leaderboard, 2, 5, 10, 20);
  else if (competitors <= 500) return trophiesDistribution(leaderboard, 10, 25, 50, 100);
  else if (competitors <= 1000) return trophiesDistribution(leaderboard, 20, 50, 100, 200);
  else if (competitors > 1000) return trophiesDistribution(leaderboard, 40, 100, 200, 400);

  return leaderboard;
}

const trophiesDistribution = (leaderboard, goldIndex, silverIndex, bronzeIndex, ironIndex) =>
  leaderboard.map((entry, index) => {
    if (index < goldIndex) return { ...entry, color: 'gold' };
    else if (index < silverIndex) return { ...entry, color: 'silver' };
    else if (index < bronzeIndex) return { ...entry, color: 'bronze' };
    else if (index < ironIndex) return { ...entry, color: 'iron' };
    return entry;
  });
